/**
 * WordPress dependencies
 */
import { createContext } from '@wordpress/element';
var RadioContext = createContext({
  state: null,
  setState: function setState() {}
});
export default RadioContext;
//# sourceMappingURL=index.js.map